/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    $(window).scroll(function () {
        if ($(window).scrollTop() >= 50) {
            $('.main-header').addClass('fixed-header');
        } else {
            $('.main-header').removeClass('fixed-header');
        }
    });

    //Check to see if the window is top if not then display button
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 100) {
            jQuery('.scrollToTop').fadeIn();
        } else {
            jQuery('.scrollToTop').fadeOut();
        }
    });

    //Click event to scroll to top   
    jQuery('.scrollToTop').click(function () {
        jQuery('html, body').animate({scrollTop: 0}, 800);
        return false;
    });

    //Technology page match height
    function equalBlocks() {
        if (jQuery(window).width() >= 768) {
            jQuery('.text-container').height(jQuery('.img-bg-contain').height());
        }
    }

    jQuery(window).load(function () {
        equalBlocks();
    });

    jQuery(document).ready(function () {
        equalBlocks();
    });

    jQuery(window).resize(function () {
        equalBlocks();
    });

    //program detail page image frame
    jQuery("<div class='image-frame'></div>").insertAfter('.single-program .wpb_single_image .vc_figure, .page-template-template-kastle .wpb_single_image .vc_figure');

    // Tetsimonials slider initialize 
    jQuery('.testimonial-wrap').slick({
        arrows: false,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000
    });

    // PrettyPhoto settings
    /*jQuery("a[rel^='prettyPhoto']").prettyPhoto({
     theme: 'facebook',
     slideshow:5000, 
     autoplay_slideshow:true
     });*/

    // SVG image color change
    jQuery(function () {
        jQuery('img.svg').each(function () {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, else we gonna set it if we can.
                if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
                }

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        });
    });
    
    // activity chart text formatting
    jQuery(".activity-title h2").html(function() {
        var text = jQuery(this).text().split(':');
        var last = text.pop();
        return text.join(":") + (text.length > 0 ? ': <span class="last">' + last + '</span>' : last);
    });

    // Join us modal popup On close reset form
    jQuery("#joinus .close").on("click", function () {
        jQuery("#joinus form").removeClass("invalid");
        jQuery("#joinus form input").removeClass("wpcf7-not-valid");
        jQuery("#joinus form label span.wpcf7-not-valid-tip").remove();
        jQuery("#joinus form .wpcf7-validation-errors").hide();
        jQuery("#joinus form")[0].reset();
    });


    //create an array to store processed data-layer type        
    jQuery(window).load(function () {
       jQuery('.activity-block .activity-main .img-top').each(function(){
        var dataColor = jQuery(this).data('color');
        console.log(dataColor);      
        jQuery(this).find('path').css('fill',dataColor);    
      }); 
    });    
    



})(jQuery); // Fully reference jQuery after this point.
